import {
  SetSubtitleValRequest,
  SetSubtitleValRequestAction,
  SetSubtitleValSuccess,
  SetSubtitleValSuccessAction,
} from '../types';

export const SET_SUBTITLE_ACTION = 'SET_SUBTITLE_ACTION';
export const SET_SUBTITLE_SUCCESS_ACTION = 'SET_SUBTITLE_SUCCESS_ACTION';

export const setSubtitleVal = (
  params: SetSubtitleValRequest,
): SetSubtitleValRequestAction => {
  return {
    type: SET_SUBTITLE_ACTION,
    value: params.val,
    sectionId: params.sectionId,
  };
};

export const setSubtitleValSuccess = (
  params: SetSubtitleValSuccess,
): SetSubtitleValSuccessAction => {
  return {
    type: SET_SUBTITLE_SUCCESS_ACTION,
    value: params.value,
  };
};
